import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';
import MobileContext from 'context/MobileContext';
import HeaderOnboarding from './HeaderOnboarding';

const HeaderFooterLayoutOnboarding = ({
  children,
  currentStep = 1,
  totalSteps = 5,
  onBackClick,
}) => {
  const isMobile = useContext(MobileContext);

  return (
    <div className={styles.templateWrapper}>
      <HeaderOnboarding
        currentStep={currentStep}
        showBackButton={currentStep > 1}
        onBackClick={onBackClick}
      />
      <div className={styles.mainWrapper}>
        {/* Stepper UI */}
        <div className={styles.stepperContainer}>
          <div className={styles.stepCounter}>
            {currentStep} of {totalSteps}
          </div>
          <div className={styles.progressBarContainer}>
            <div
              className={`${styles.progressBar} ${
                currentStep === totalSteps ? styles.fullProgress : ''
              }`}
              style={{ width: `${(currentStep / totalSteps) * 100}%` }}
            />
          </div>
        </div>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

HeaderFooterLayoutOnboarding.propTypes = {
  children: PropTypes.node.isRequired,
  currentStep: PropTypes.number,
  totalSteps: PropTypes.number,
  onBackClick: PropTypes.func,
};

HeaderFooterLayoutOnboarding.defaultProps = {
  currentStep: 1,
  totalSteps: 5,
  onBackClick: () => {},
};

export default HeaderFooterLayoutOnboarding;
